import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  useGetChangeReportMutation
} from '../../../../../features/authentication/assignApiSlice';
import {
  useGetFlashcardChangeReportMutation
} from '../../../../../features/authentication/activityApiSlice';
import Prot from '../../../../../assets/images/Prot.svg';
import noProt from '../../../../../assets/images/noProt.svg';
import PMB from '../../../../../assets/images/math-blocker.svg';
import noRulr from '../../../../../assets/images/ruler-disabled.svg';
import Rulr from '../../../../../assets/images/ruler.svg';
import 'font-awesome/css/font-awesome.min.css';
import { useAssignmentContext } from '../../../context';
import { useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import QuestionPreviewModal from '../../../components/QuestionPreviewModal';
import ProgressButton from '../../../../../components/ProgressButton';
import ActivityTypes from '../../../../../enums/activityTypes';
import { useActivityContext } from '../../../../activities/context';
import { ActivityUtils } from '../../../../activitySearch/activityUtils';

const AssignmentChanges = () => {
  const location = useLocation();
  const { state } = location;
  const [assignmentName, setAssignmentName] = useState('');
  const [selectedAssignmentId, setSelectedAssignmentId] = useState('');
  const [isCheckedBoldDescription, setIsCheckedBoldDescription] = useState(false);
  const [changeReport, setChangeReport] = useState([]);
  const [isHideRetake, setIsHideRetake] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [isIndex, setIsIndex] = useState([]);
  const [isQuestionId, setIsQuestionId] = useState([]);
  const { Id, activityType } = useParams();
  const [getChangeReport] = useGetChangeReportMutation();
  const [getFlashcardChangeReport] = useGetFlashcardChangeReportMutation();
  const assignmentContext = useAssignmentContext();
  const activityContext = useActivityContext();
  const context = activityType == ActivityTypes.Assignment ? assignmentContext : activityContext;
  const navigate = useNavigate();
  const [questionId, setQuestionId] = useState();
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const replacements = [
    {
      find: 'noRS',
      replace:
        '<span title=\'Text-to-Speech Disabled\'></i><i style="color:red;" class=\'fa fa-solid fa-volume-slash\'></i></span>',
      style: 'img-icon'
    },
    {
      find: 'RS',
      replace:
        '<span title=\'Text-to-Speech Enabled\'><i class=\'fa fa-volume-up volume-icon\'></i></span>',
      style: 'img-icon'
    },
    {
      find: 'options: R',
      replace: '<span title = \'Assignment questions are randomized\'>Randomized</span>',
      style: ''
    },
    {
      find: 'LC',
      replace:
        '<span title = \'Allowed to change the display language while taking this assignment\'>Language Change</span>',
      style: ''
    },
    {
      find: 'noLC',
      title: 'Not allowed to change the display language while taking this assignment',
      replace: 'Language Change',
      style: 'strike'
    },
    {
      find: 'tot',
      replace:
        '<span title = \'The amount of time the student takes answering questions will be tracked\'>Time on Task</span>',
      style: ''
    },
    {
      find: 'notot',
      title: 'The amount of time the student takes answering questions is not tracked',
      replace: 'Time on Task',
      style: 'strike'
    },
    {
      find: 'Calc',
      replace:
        '<i style="color:red;" title=\'A 4 Function calculator is available on screen for this assignment\' class="fa fa-calculator calc-icon"></i>&nbsp;&nbsp;',
      style: 'img-icon'
    },
    {
      find: 'noCalc',
      replace:
        '<div class=\'overlap-icon\'><i title=\'A 4 Function calculator is not available on screen for this assignment\' class="fa fa-ban ban-icon"></i><i style="color:red;" class="fa fa-calculator calc-icon"></i></div>&nbsp;&nbsp;',
      style: 'img-icon'
    },
    {
      find: 'CalcS',
      replace:
        '<i title=\'A Scientific calculator is available on screen for this assignment\' class="fa fa-calculator calc-icon"></i>&nbsp;&nbsp;',
      style: 'img-icon'
    },
    {
      find: 'noCalcS',
      replace:
        '<div class=\'overlap-icon\'><i title=\'A Scientific calculator is not available on screen for this assignment\' class="fa fa-ban ban-icon"></i><i class="fa fa-calculator calc-icon"></i></div>&nbsp;&nbsp;',
      style: 'img-icon'
    },
    {
      find: 'Prot',
      title: 'A Protractor is available on screen for this assignment',
      replace: Prot,
      style: 'img'
    },
    {
      find: 'noProt',
      title: 'A Protractor is not available on screen for this assignment',
      replace: noProt,
      style: 'img'
    },
    {
      find: 'Rulr',
      title: 'A Ruler is available on screen for this assignment',
      replace: Rulr,
      style: 'img'
    },
    {
      find: 'noRulr',
      title: 'A Ruler is not available on screen for this assignment',
      replace: noRulr,
      style: 'img'
    },
    {
      find: 'PMB',
      title: 'Photomath Blocked Enabled',
      replace: PMB,
      style: 'img'
    },
    {
      find: 'Not Timed',
      replace: '<span title = \'This assignment is not timed\'>Not Timed</span>',
      style: ''
    },
    { find: 'Timed', replace: '<span title = \'This assignment is timed\'>Timed</span>', style: '' },
    { find: '<span>Update</span> sharedwith:', style: 'icon' },
    { find: '<span>Add</span> reading set questions:', style: 'link' },
    { find: '<span>Add</span> question:', style: 'link' },
    { find: '<span>Add</span> questions:', style: 'link' },
    { find: '<span>Remove</span> question:', style: 'link' },
    { find: '<span>Remove</span> questions:', style: 'link' },
    { find: '<span>to Students</span>:', style: 'link' }
  ];

  const replaceKeywords = (index, description, replacements) => {
    let replacedText = description;
    replacements.forEach(({ find, replace, style, title }) => {
      const regex = new RegExp(`\\b${find}\\b`, 'gi');
      if (style === 'strike') {
        replacedText = replacedText.replace(
          regex,
          `<div class='strike' title='${title}'>${replace}</div>`
        );
      } else if (style === 'img') {
        if (find === 'PMB') {
          replacedText = replacedText.replace(
            find,
            `<img title='${title}' src=${replace} class='key-icon' />`
          );
        } else {
          replacedText = replacedText.replace(
            regex,
            `<img title='${title}' src=${replace} class='key-icon' />`
          );
        }
      } else if (style === 'img-icon') {
        if (find === 'noRS') {
          replacedText = replacedText.replace(find, replace);
        } else if (find === 'RS') {
          replacedText = replacedText.replace(find, replace);
        } else replacedText = replacedText.replace(regex, replace);
      } else if (style === 'icon') {
        const searchString = '<span>Update</span> sharedwith:';
        const commaSeparatedDataLengthThreshold = 10;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;
          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${commaSeparatedData}`
              : isIndex.includes(index)
                ? `${commaSeparatedData + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else if (find === '<span>Add</span> reading set questions:' && style === 'link') {
        const searchString = '<span>Add</span> reading set questions:';
        const commaSeparatedDataLengthThreshold = 10;
        let questionId;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;

          const modifiedDescription = commaSeparatedData.replace(
            /(<a[^>]+>)([^<]+)(<\/a>)/g,
            (match, openingTag, content, closingTag) => {
              const questionCode = content.trim().substring(0, 1); // Extract the question code without the first character
              questionId = content.trim().substring(1); // Extract the question ID without the first character
              //remove onclick from <a> element
              const modifiedOpeningTag = openingTag.replace(/onclick=['"][^'"]+['"]/g, '');
              // Add the data-id attribute with the question ID
              const modifiedOpeningTagWithAttributes = modifiedOpeningTag.replace(
                '>',
                ` data-code='${questionCode}' data-id="${questionId}">`
              );
              return modifiedOpeningTagWithAttributes + content + closingTag;
            }
          );

          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${modifiedDescription}`
              : isIndex.includes(index)
                ? `${modifiedDescription + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else if (find === '<span>Add</span> question:' && style === 'link') {
        const searchString = '<span>Add</span> question:';
        const commaSeparatedDataLengthThreshold = 10;
        let questionId;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;

          const modifiedDescription = commaSeparatedData.replace(
            /(<a[^>]+>)([^<]+)(<\/a>)/g,
            (match, openingTag, content, closingTag) => {
              const questionCode = content.trim().substring(0, 1); // Extract the question code without the first character
              questionId = content.trim().substring(1); // Extract the question ID without the first character
              //remove onclick from <a> element
              const modifiedOpeningTag = openingTag.replace(/onclick=['"][^'"]+['"]/g, '');
              // Add the data-id attribute with the question ID
              const modifiedOpeningTagWithAttributes = modifiedOpeningTag.replace(
                '>',
                ` data-code='${questionCode}' data-id="${questionId}">`
              );

              return modifiedOpeningTagWithAttributes + content + closingTag;
            }
          );

          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${modifiedDescription}`
              : isIndex.includes(index)
                ? `${modifiedDescription + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else if (find === '<span>to Students</span>:' && style === 'link') {
        const searchString = '<span>to Students</span>:';
        const commaSeparatedDataLengthThreshold = 10;
        let questionId;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;

          const modifiedDescription = commaSeparatedData.replace(
            /(<a[^>]+>)([^<]+)(<\/a>)/g,
            (match, openingTag, content, closingTag) => {
              const questionCode = content.trim().substring(0, 1); // Extract the question code without the first character
              questionId = content.trim().substring(1); // Extract the question ID without the first character
              //remove onclick from <a> element
              const modifiedOpeningTag = openingTag.replace(/onclick=['"][^'"]+['"]/g, '');
              // Add the data-id attribute with the question ID
              const modifiedOpeningTagWithAttributes = modifiedOpeningTag.replace(
                '>',
                ` data-code='${questionCode}' data-id="${questionId}">`
              );

              return modifiedOpeningTagWithAttributes + content + closingTag;
            }
          );

          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${modifiedDescription}`
              : isIndex.includes(index)
                ? `${modifiedDescription + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else if (find === '<span>Add</span> questions:' && style === 'link') {
        const searchString = '<span>Add</span> questions:';
        const commaSeparatedDataLengthThreshold = 10;
        let questionId;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;

          const modifiedDescription = commaSeparatedData.replace(
            /(<a[^>]+>)([^<]+)(<\/a>)/g,
            (match, openingTag, content, closingTag) => {
              const questionCode = content.trim().substring(0, 1); // Extract the question code without the first character
              questionId = content.trim().substring(1); // Extract the question ID without the first character
              //remove onclick from <a> element
              const modifiedOpeningTag = openingTag.replace(/onclick=['"][^'"]+['"]/g, '');
              // Add the data-id attribute with the question ID
              const modifiedOpeningTagWithAttributes = modifiedOpeningTag.replace(
                '>',
                ` data-code='${questionCode}' data-id="${questionId}">`
              );

              return modifiedOpeningTagWithAttributes + content + closingTag;
            }
          );

          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${modifiedDescription}`
              : isIndex.includes(index)
                ? `${modifiedDescription + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else if (find === '<span>Remove</span> question:' && style === 'link') {
        const searchString = '<span>Remove</span> question:';
        const commaSeparatedDataLengthThreshold = 10;
        let questionId;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;

          const modifiedDescription = commaSeparatedData.replace(
            /(<a[^>]+>)([^<]+)(<\/a>)/g,
            (match, openingTag, content, closingTag) => {
              const questionCode = content.trim().substring(0, 1); // Extract the question code without the first character
              questionId = content.trim().substring(1); // Extract the question ID without the first character
              //remove onclick from <a> element
              const modifiedOpeningTag = openingTag.replace(/onclick=['"][^'"]+['"]/g, '');
              // Add the data-id attribute with the question ID
              const modifiedOpeningTagWithAttributes = modifiedOpeningTag.replace(
                '>',
                ` data-code='${questionCode}' data-id="${questionId}">`
              );

              return modifiedOpeningTagWithAttributes + content + closingTag;
            }
          );

          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${modifiedDescription}`
              : isIndex.includes(index)
                ? `${modifiedDescription + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else if (find === '<span>Remove</span> questions:' && style === 'link') {
        const searchString = '<span>Remove</span> questions:';
        const commaSeparatedDataLengthThreshold = 10;
        let questionId;

        const startIndex = replacedText.indexOf(searchString);
        if (startIndex !== -1) {
          const commaSeparatedData = replacedText.substring(startIndex + searchString.length);
          const commaSeparatedDataLength = commaSeparatedData.split(',').length;
          const iconHtml = `&nbsp;&nbsp;<i class='fa fa-caret-right' data-index='${index}'></i>`;
          const iconHtmlLeft = `&nbsp;&nbsp;<i class='fa fa-caret-left' data-index='${index}'></i>`;

          const modifiedDescription = commaSeparatedData.replace(
            /(<a[^>]+>)([^<]+)(<\/a>)/g,
            (match, openingTag, content, closingTag) => {
              const questionCode = content.trim().substring(0, 1); // Extract the question code without the first character
              questionId = content.trim().substring(1); // Extract the question ID without the first character
              //remove onclick from <a> element
              const modifiedOpeningTag = openingTag.replace(/onclick=['"][^'"]+['"]/g, '');
              // Add the data-id attribute with the question ID
              const modifiedOpeningTagWithAttributes = modifiedOpeningTag.replace(
                '>',
                ` data-code='${questionCode}' data-id="${questionId}">`
              );

              return modifiedOpeningTagWithAttributes + content + closingTag;
            }
          );

          const updatedContent =
            commaSeparatedDataLength <= commaSeparatedDataLengthThreshold
              ? `${modifiedDescription}`
              : isIndex.includes(index)
                ? `${modifiedDescription + iconHtmlLeft}`
                : (replacedText = replacedText.replace(commaSeparatedData, iconHtml));
          replacedText = replacedText.replace(commaSeparatedData, updatedContent);
        }
      } else {
        replacedText = replacedText.replace(regex, replace);
      }
    });
    return replacedText;
  };

  const handleDescriptionBold = (e) => {
    const { checked } = e.target;
    setIsCheckedBoldDescription(checked);
  };

  const handleHideRetake = (e) => {
    const { checked } = e.target;
    const keyword = 'Retake Auto-Generated';
    if (checked) {
      const report = changeReport.filter((item) => {
        return typeof item.description === 'string' && !item.description.includes(keyword);
      });
      setChangeReport(report);
      setIsHideRetake(checked);
    } else {
      getChangeReportAsync();
      setIsHideRetake(false);
    }
  };

  const getChangeReportAsync = async () => {
    const isFlashcard = String(activityType) === String(ActivityTypes.FlashCard);
    const resolvedId = Id ?? (isFlashcard ? activityContext.activityId : assignmentContext.assignmentId);
    const options = isFlashcard ? { id: resolvedId } : { assignmentId: resolvedId };
    const fetchChangeReport = isFlashcard ? getFlashcardChangeReport : getChangeReport;
    const changeReportResponse = await fetchChangeReport(options).unwrap();

    setChangeReport(changeReportResponse);
  };

  const getQuestionsAsync = async (questionId) => {
    setQuestionId(questionId);
    setOpenPreview(true);
  };

  const handlePrintPDF = async () => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const contentWrapper = document.getElementById('change-report');
    const contentClone = contentWrapper.cloneNode(true);
    const checkboxes = contentClone.querySelectorAll('.checkboxes');
    const tables = contentClone.getElementsByTagName('table');

    checkboxes.forEach((element) => {
      element.style.display = 'none';
    });

    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    const options = {
      margin: 40,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };
    await html2pdf().set(options).from(contentClone).save(`${assignmentName}_${Id}.pdf`);
    setIsPdfGenerating(false);
  };

  useEffect(() => {
    const images = document.querySelectorAll('img');
    const url = window.location.pathname;
    if (url.includes('/assignments/')) {
      images.forEach(function (currentImage) {
        const currentSrc = currentImage.getAttribute('src');
        const imgPath = currentSrc.split('/static');
        const newSrc = window.location.origin + '/static' + imgPath[1];
        currentImage.setAttribute('src', newSrc);
      });
    }
  }, []);

  useEffect(() => {
    if (state != null && state.assignmentName != null && state.assignmentName?.length > 0) {
      setAssignmentName(state.assignmentName);
    } else {
      setAssignmentName(context.assignmentName);
    }
    Id === undefined || Id === null
      ? setSelectedAssignmentId(context.assignmentId)
      : setSelectedAssignmentId(Id);
    getChangeReportAsync();
  }, []);

  useEffect(() => {
    // Event delegation to handle click events on the dynamically generated <i> elements
    const handleIconClick = (event) => {
      let indexArray = [];
      const index = event.target.dataset.index;
      if (index !== undefined) {
        // Handle the click event for the specific index
        let indexValue = parseInt(index);
        if (isIndex.includes(indexValue)) {
          setIsIndex(isIndex.filter((item) => item !== indexValue));
        } else {
          indexArray.push(...isIndex, indexValue);
          setIsIndex(indexArray);
        }
      }
    };

    // Attach the event listener to a static parent element (e.g., document or a specific parent container)
    document.addEventListener('click', handleIconClick);

    return () => {
      // Clean up the event listener when the component is unmounted
      document.removeEventListener('click', handleIconClick);
    };
  }, [isIndex]);

  useEffect(() => {
    // Event delegation to handle click events on the dynamically generated <a> elements
    const displayquestion = (event) => {
      let questionIdArray = [];
      const questionId = event.target.dataset.id;
      if (questionId !== undefined) {
        // Handle the click event for the specific questionId
        let questionIdValue = parseInt(questionId);
        getQuestionsAsync(questionIdValue);
        if (isQuestionId.includes(questionIdValue)) {
          setIsQuestionId(isQuestionId.filter((item) => item !== questionIdValue));
        } else {
          questionIdArray.push(...isQuestionId, questionIdValue);
          setIsQuestionId(questionIdArray);
        }
      }
    };

    // Attach the event listener to a static parent element (e.g., document or a specific parent container)
    document.addEventListener('click', displayquestion);

    return () => {
      // Clean up the event listener when the component is unmounted
      document.removeEventListener('click', displayquestion);
    };
  }, [isQuestionId]);

  return (
    <div className="white-card">
      <div className="student_response_header">
        <div>
          <h3 className="primary-title mb-md-0">{ActivityUtils.getActivityName(activityType)} Changes Report: {assignmentName}</h3>
        </div>
        <div className="d-flex justify-content-end gap-3">
          <button id="back_button" className="btn btn-width btn-castleWhite" onClick={() => navigate(-1)}>
            Back
          </button>
          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={handlePrintPDF}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleRed"
            expectedDuration={1500}
          />
        </div>
      </div>
      <div id="change-report">
        <div className="align-items-center d-flex gap-5 mb-4">
          <div className="d-flex form-check gap-3 checkboxes">
            <input
              type="checkbox"
              value=""
              name={'boldDescription'}
              checked={isCheckedBoldDescription}
              onChange={handleDescriptionBold}
              className="form-check-input flex-shrink-0"
              id={selectedAssignmentId}
            />
            <label className="form-check-label" htmlFor={'boldDescription'}>
              {' '}
              Make key Description text bold
            </label>
          </div>
          {activityType !== ActivityTypes.Assessment && <div className="d-flex form-check gap-3">
            <input
              type="checkbox"
              value=""
              name={'hideDisplay'}
              checked={isHideRetake}
              onChange={handleHideRetake}
              className="form-check-input flex-shrink-0"
              id={selectedAssignmentId}
            />
            <label className="form-check-label" htmlFor={'hideDisplay'}>
              {' '}
              Hide rows that display Retake Auto-Generated {ActivityUtils.getActivityName(activityType).toLocaleLowerCase()}
            </label>
          </div>
          }
        </div>
        <div className="custom-table table-responsive">
          <table className="table currentlist-table change-report-table">
            <thead>
              <tr>
                <th>Sl.No.</th>
                <th>Description</th>
                <th>Done By</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {changeReport.map((item, index) => {
                return (
                  <tr key={`report-${index}`}>
                    <td>{index + 1}</td>
                    <td
                      className={`text-align-center ${isCheckedBoldDescription ? 'wrap-data bold-description' : 'wrap-data'}`}
                      dangerouslySetInnerHTML={{
                        __html: replaceKeywords(index, item.description, replacements)
                      }}></td>
                    <td>{item.doneBy}</td>
                    <td>{item.date}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {openPreview && (
            <QuestionPreviewModal
              isOpen={openPreview}
              onClose={() => setOpenPreview(false)}
              questionId={questionId}
              assignmentId={parseInt(Id)}
              isPublicAssignment={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignmentChanges;
